import {useQuery} from 'react-query';
import {getInitialSponsorInformation} from './index';
const useGetInitialSponsorInformation = () => {
  const {data, isLoading} = useQuery({
    queryKey: ['sponsorInfo'],
    queryFn: getInitialSponsorInformation,
  });
  return {sponsorInfo: data, isLoading};
};

export default useGetInitialSponsorInformation;
